<template>
<div>
    <div class="upload-content" v-if="attrs.mode == 'edit'">
        <Upload 
            ref="upload"
            :action="attrs.api"
            :headers="headers"
            :on-success="handleSuccess"
            :max-size="maxSize"
            :before-upload="handleBeforeUpload"
            style="display:inline-block;"
            multiple
            type="drag"
            :default-file-list="uploadList"
            :on-remove="handleRemove">
            <div style="height:58px;line-height: 58px;">
                <Icon type="ios-cloud-upload" size="20"></Icon>
            </div>
        </Upload>
        <div class="tips">{{attrs.tips}}</div>
    </div>
    <div class="file-upload-list" 
            v-for="(item, index) in uploadList" :key="index">
        <template v-if="item.url && item.url.length > 0 && attrs.mode != 'edit'">
            <a :href="item.url" :download="item.name">{{item.name}} <Icon type="md-cloud-download" /></a>
        </template>
        <template v-else>
            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
        </template>
    </div>
</div>
    
</template>
<script>
/**
     * attrs 中的参数
     * {
     *     tips: 上传显示的文字提示,
     *     max: 图片上传的最大数量,
     *     api: 图片上传的api地址,
     *     mode: 当前模式,[show: 显示模式, edit: 编辑模式]
     * }
     */
    import {mapGetters} from 'Vuex'
    export default {
        name: 'LyFileUploadForm',
        props: {
            value: {
                type: [String, Array],
                default: ''
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            },
            page: {
                type: Object,
                default: _ => {}
            }
        },
        computed: {
            ...mapGetters(['tokon'])
        },
        data () {
            return {
                headers: {}, // 设置上传的请求头部
                defaultList: [], // 默认显示的图片
                visible: false,
                uploadList: [],
                max: 3, // 能上传图片的数量
                maxSize: 1024,//默认为1M
            }
        },
        watch: {
            value: {
                handler (val) {
                    this.initUploadList()
                },
                immediate: true
            }
        },
        mounted () {
            this.headers = {
                Authorization: this.tokon
            }
        },
        methods: {
            initUploadList () {
                if (this.value && this.value.length > 0) {
                    this.uploadList = []
                    this.value.forEach((el) => {
                        this.uploadList.push(el)
                    })
                } else {
                    this.uploadList = []
                }
            },
            /**
             * 上传成功后的处理
             */
            handleSuccess (res, file) {
                if (res.status == 200) {
                    this.uploadList.push({
                        url: res.data.url,
                        name: file.name
                    })
                    this.sendInput()
                } else {
                    this.$Message.error({content: res.msg, duration: 5 })
                }
            },
            /**
             * 移除
             */
            handleRemove (file, fileList) {
                this.$emit('input', fileList)
            },
            /**
             * 文件过大的提示，先默认1MB
             */
            handleMaxSize (file) {
                let rs = parseInt(this.maxSize)/1024
                this.$Notice.warning({
                    desc: '上传的图片,体积不能超过'+rs+'MB'
                });
            },
            /**
             * 限制上传的数量
             */
            handleBeforeUpload (file) {
                let check = this.uploadList.length < (this.attrs.max || 1)
                if (!check) {
                    this.$Notice.warning({
                        title: '只能上传' + this.attrs.max + '个文件'
                    });
                }
                return check
            },
            /**
             * 数据改变的通知
             */
            sendInput () {
                // let data = []
                // this.uploadList.forEach((el) => {
                //     data.push(el)
                // })
                this.$emit('input', this.uploadList)
            },
            /**
             * 文件下载
             */
            handleDownload(file) {
                window.open(file)
            }
        }
    }
</script>
<style>
    .upload-content .ivu-upload .ivu-upload-drag {
        width:130px;
    }
    .file-upload-list {
        display: inline-block;
        width: auto;
        margin-right: 30px;     
        line-height: 30px;   
    }
    .file-upload-list a {
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/file-upload-form/src/index.vue